<template>
  <div class="s_system_config_base g-flex-column" v-show="show">
    <el-form ref="form" :model="form" label-width="300px" label-position="right">
      <el-row :gutter="24">
        <el-col :span="10">
          <el-form-item label="邀请人首单任务奖励（元）: ">
            <el-input placeholder="请输入内容" v-model="form.spread_first"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="10">
          <el-form-item label="邀请1-20人 一级代理佣金：（%）">
            <el-input placeholder="请输入内容" v-model="form.spread_20_1"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="邀请1-20人 二级代理佣金：（%）">
            <el-input placeholder="请输入内容" v-model="form.spread_20_2"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="10">
          <el-form-item label="邀请20-50人 一级代理佣金：（%）">
            <el-input placeholder="请输入内容" v-model="form.spread_50_1"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="邀请20-50人 二级代理佣金：（%）">
            <el-input placeholder="请输入内容" v-model="form.spread_50_2"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="10">
          <el-form-item label="邀请50-150人 一级代理佣金：（%）">
            <el-input placeholder="请输入内容" v-model="form.spread_150_1"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="邀请50-150人 二级代理佣金：（%）">
            <el-input placeholder="请输入内容" v-model="form.spread_150_2"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="10">
          <el-form-item label="邀请150人以上 一级代理佣金：（%）">
            <el-input placeholder="请输入内容" v-model="form.spread_1"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="邀请150人以上 二级代理佣金：（%）">
            <el-input placeholder="请输入内容" v-model="form.spread_2"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item>
        <el-button type="primary" size="large" @click="submitClick">确定修改</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { apiGetSystemConfig, apiSetSystemConfig } from '@/utils/api.js'
  export default {
    data() {
      return {
        code: '',
        show: false,
        form: {
          spread_first: '',
          spread_20_1: '',
          spread_20_2: '',
          spread_50_1: '',
          spread_50_2: '',
          spread_150_1: '',
          spread_150_2: '',
          spread_1: '',
          spread_2: ''
        }
      }
    },
    methods: {
      onShow(code) {
        this.code = code
        this.show = true
        this.apiGetSystemConfigHandel()
      },

      async apiGetSystemConfigHandel() {
        let loading = this.$loading()
        const { success, data } = await apiGetSystemConfig({ code: this.code}).catch(() => loading.close())
        loading.close()
        if(!success) return
        this.form = data.data
        console.log(data)
      },

      async submitClick() {
        let loading = this.$loading()
        const { success, data } = await apiSetSystemConfig({ code: this.code, config: this.form }).catch(() => loading.close())
        loading.close()
        if(!success) return
         this.$message.success(data.msg)
      },
    }

  }
</script>

<style lang="scss">
.s_system_config_base {
  .s-system-config-base-btn {
    padding-top: 30px;
  }
}
</style>